module.exports = __webpack_public_path__ + "static/media/logo-mobile.3f8f44ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/cyber-monday/logo-mobile.png
// module id = 1460
// module chunks = 0